import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslationsInGrid from "../editTranslationsInGrid";
import { SubDocumentCategoryViewModel } from "./editDocumentSubCategoriesGrid";
import React from "react"
export default class EditDocumentSubCategory extends React.Component<EditDocumentSubCategoryProps, any>{
    private common = new AppHelper();
    private translationInGridRef: EditTranslationsInGrid;

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    save = async (closeAfterSave) => {
        var result = await HTTPService.post<JsonResultClass>("SubDocumentsSettings/SaveSubCategory", this.props.entity);
        if (result.Code == 0) {
            this.common.setEntityDirtyState(false);
            this.props.entity.Id = result.Data;
            this.props.entity.IsNew = false;
            this.translationInGridRef.markAsSaved();
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.handlePostSave(result.Code === 0, closeAfterSave);
        this.setState({});
    }

    renderEditTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Value0",
                title: Helper.getTranslation("Standard.Name")
            }
        ];

        return <EditTranslationsInGrid
            id={"editDocumentSubCategoryTranslationsInGrid"}
            gridData={this.props.entity.Translations}
            translationColumns={translationColumns}
            setEntityDirtyState={(isDirty) => this.common.setEntityDirtyState(isDirty)}
            ref={(ref) => this.translationInGridRef = ref} />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditDocumentSubCategoryProps extends AppBaseProps {
    entity: SubDocumentCategoryViewModel;
}